
const initialState = {
    is_authenticated: false,
    is_loading: false,
    error: null
};

export default function auth(state=initialState, action){
    switch (action.type){
        case 'LOGIN_SUCCESS':
            localStorage.setItem("token_cafe", action.data);
            return { is_authenticated:true, is_loading: false, error: null};
        case 'LOGIN_FAILED':
            return {...state, is_authenticated: false, is_loading: false, error: 'Usuario no encontrado o datos no válidos'};
        case 'LOGIN_LOADING':
            return {...state, is_authenticated: false, is_loading: true, error: null};
        case 'LOGOUT_SUCCESSFUL':
            localStorage.removeItem("token_cafe");
            return {...state, is_authenticated: false, is_loading: false, error: null};
        default:
            return state;

    }
}